import { SystemContext } from "./SystemContext";
import * as React from "react";
 class SystemProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      queryFilter: window.queryFilter, setGlobalState: this.setGlobalState
    };
  }
  setGlobalState = (param = false,bookmarkparam = true)=>{
    // console.log("state update")
    // alert('sdfgvcxcvbnbvcxcvbn')
    var queryFilter = this.state.queryFilter;
    for (const [key, value] of Object.entries(param)) {
      queryFilter[key] = value;
    }
    if(param ){      
      this.setState({queryFilter});
      if (bookmarkparam) {
      this.setBookMarking();
      }
    }
   }
  
   setBookMarking = () => {
      if (history.pushState) {
        var link = '';
        link += `?`;
        if (this.state.queryFilter["searchkey"]){
          link += `&searchkey=${btoa(this.state.queryFilter["searchkey"])}`;
        }
        if (this.state.queryFilter["startdate"]) {
          link += `&startdate=${btoa(this.state.queryFilter["startdate"])}`;
        }
        if (queryFilter["enddate"]) {
          link += `&enddate=${btoa(this.state.queryFilter["enddate"])}`;
        }
        if (queryFilter["product_name"] && queryFilter["product_name"] != '') {
          link += `&product_name=${btoa(this.state.queryFilter["product_name"])}`;
        }
        if (queryFilter["product_id"] && queryFilter["product_id"] != '') {
          link += `&product_id=${btoa(this.state.queryFilter["product_id"])}`;
        }
        if (queryFilter["product_type"] && queryFilter["product_type"] != '') {
          link += `&product_type=${btoa(this.state.queryFilter["product_type"])}`;
        }
        window.history.pushState({
          path: link
        }, '', link);
        
      }
    }
  render() {
    return (
      <SystemContext.Provider
        value={{
            ...this.state
        }}
      >
        {this.props.children}
      </SystemContext.Provider>
    );
  }
}
export default SystemProvider;